import 'moment/locale/he';
import moment from 'moment-timezone';

moment.tz.setDefault('Israel');
